import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Popup } from "components/UI/Popup";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "store/app-state";
import { addGifToCollection, fetchMyCollections, setEmptyCollections } from "../../../../store/collections/collections-action";
import { CreateNewCollectionPopup } from "./CreateNewCollectionPopup";
import { useIsAuth } from "hooks/useIsAuth";
import { showAuthModal } from "store/application/application-action";
import { metrics } from "utils/metrics";
import { CollectionItem } from "./CollectionItem";
import { BaseButton } from "components/buttons/BaseButton";
import "./styles/AddToCollectionPopup.scss";

interface IAddToCollectionPopupProps {
  isOpen: boolean;
  togglePopup: () => void;
  gifId: string;
}

export const AddToCollectionPopup = ({ isOpen, togglePopup, gifId }: IAddToCollectionPopupProps) => {
  const collections = useSelector((state: IAppState) => state.collections.collections);
  const isLoading = useSelector((state: IAppState) => state.collections.loading);
  const [isNewCollectionPopupOpen, setIsOpenNewCollectionPopup] = useState(false);
  const isAuth = useIsAuth();
  const dispatch = useDispatch();

  const toggleCreateNewCollectionPopup = () => {
    setIsOpenNewCollectionPopup(prev => !prev);
  };

  const addToCollections = async (folderId: string) => {
    dispatch(addGifToCollection({
      collectionId: folderId,
      gifId: gifId
    }));
    await metrics.sendAddedToCollection({ gif: gifId });
    // @ts-ignore
    togglePopup();
  };

  const handleLogin = () => {
    dispatch(showAuthModal());
  };

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchMyCollections({
        page: 1,
        count: 100
      }));
    }
    return () => {
      dispatch(setEmptyCollections());
    };
    // eslint-disable-next-line
  }, [isOpen])

  const btnProps = {
    type: 2,
    title: "Create a new collection",
    onClick: toggleCreateNewCollectionPopup,
    btnType: "submit"
  };

  return (
    <Popup
      title="Add to collection"
      isOpen={isOpen}
      popupClass="AddToCollectionPopup"
      btnProps={btnProps}
      onClose={togglePopup}
    >
      {isLoading && <CircularProgress
        sx={{
          color: "var(--red-accent)",
          margin: "auto",
          display: "block"
        }}
      />}
      {isAuth && (
        <ul className="AddToCollectionPopup-List">
          {collections ? collections.map((collection) => (
            <CollectionItem
              key={uuidv4()}
              collection={collection}
              addToCollections={addToCollections}
            />
          )) : (
            <li className="AddToCollectionPopup-NoCollection">
              We have some issues with loading collections. Please close and open the dialog and try again.
            </li>
          )}
        </ul>
      )}
      {!isAuth && (
        <div className="AddToCollectionPopup-Login">
          <p>You’ve gotta log in to add to collections to RedGIFs!</p>
          <BaseButton onClick={handleLogin}>Login</BaseButton>
        </div>
      )}
      <CreateNewCollectionPopup
        isOpen={isNewCollectionPopupOpen}
        togglePopup={toggleCreateNewCollectionPopup}
      />
    </Popup>
  );
};
